module.exports = __webpack_public_path__ + "img/rating--great.f6aa750a.svg";